/**
 * @file システムエラーダイアログ。APIエラー時にモーダルで表示し、apiTypeに応じたエラーメッセージを切り替える。
 *       GET系APIエラーの場合はOKボタンでTOP画面へ遷移、それ以外はダイアログを閉じるのみ。
 *       body scrollを無効化してモーダル効果を実現。
 */
import { alertState } from '@/states/alertState';
import { Constants } from '@/utils/constants';
import React from 'react';
import { useRecoilState } from 'recoil';
import url from '@/utils/config';
import SystemErrorMessage from '@/components/atoms/SystemErrorMessage';

const AlertDialog = () => {
  const [alert, setAlert] = useRecoilState(alertState);
  const onClose = () => {
    const apiTypeValue = alert.apiType;
    setAlert({
      isOpen: false,
      apiType: '',
    });
    // GET系APIエラーは画面表示の前提データが取得できないためTOPへ強制遷移、POST/PUT系は画面に留まり再操作を許容
    if (apiTypeValue === Constants.ApiType.API_GET) {
      window.location.href = url('/top');
    }
  };

  // apiTypeに応じたエラーメッセージの出し分け（オプション変更/タイムアウトは専用文言、その他は汎用エラー）
  const setMessage = () => {
    switch (alert.apiType) {
      case Constants.ApiType.OPTION_CHANGE:
        return Constants.ErrorDialogMessage.OPTION_CHANGE;
      case Constants.ApiType.TIME_OUT:
        return Constants.ErrorDialogMessage.TIME_OUT;
      default:
        return Constants.ErrorDialogMessage.DEFAULT;
    }
  };

  if (alert.isOpen) {
    // モーダル表示中は背景スクロールを禁止して操作をダイアログに集中させる
    if (typeof window === 'object') {
      document.body.style.overflow = 'hidden';
    }
    return (
      <>
        <div className='m-modal js-modal is-modal-fade is-modal-show alert-dialog'>
          <div className='m-modal__inner'>
            <div className='m-modal__content align-center'>
              <div className='text-alert'>ご確認ください</div>
              <SystemErrorMessage message={setMessage()} />
            </div>
            <div className='m-modal__footer'>
              <div className='m-button align-center'>
                <button className='m-button__inner m-button--sec' onClick={onClose}>
                  <span className='m-button__txt'>OK</span>
                  <img className='m-button__icon' src={url('/images/icon_arrow_right-02.svg')} alt='OK' />
                </button>
              </div>
            </div>
          </div>
        </div>
        <span role='button' tabIndex={0} className='fn-overlay is-overlay-show' onClick={onClose} onKeyDown={onClose} aria-label='閉じる' data-testid='show' />
      </>
    );
  }
  // ダイアログ非表示時はbodyのoverflowを復元してスクロールを再有効化
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }

  return <span className='fn-overlay' data-testid='hidden' />;
};

export default AlertDialog;
